import { Navigate, Route, Routes } from 'react-router-dom';
import { AppShell } from './components/AppShell';
import { Landing } from './pages/Landing';
import { SignIn } from './pages/SignIn';
import { Today } from './pages/Today';
import { Products } from './pages/Products';
import { NewProduct } from './pages/NewProduct';
import { ProductDetail } from './pages/ProductDetail';
import { SbomAnalysis } from './pages/SbomAnalysis';
import { KnowledgeBase } from './pages/KnowledgeBase';
import { Incidents } from './pages/Incidents';
import { NewIncident } from './pages/NewIncident';
import { ReportEditor } from './pages/ReportEditor';
import { Settings } from './pages/Settings';

export function App() {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/signin" element={<SignIn />} />
      <Route path="/app" element={<AppShell />}>
        <Route index element={<Navigate to="today" replace />} />
        <Route path="today" element={<Today />} />
        <Route path="products" element={<Products />} />
        <Route path="products/new" element={<NewProduct />} />
        <Route path="products/:id" element={<ProductDetail />} />
        <Route path="products/:id/analysis/:vid" element={<SbomAnalysis />} />
        <Route path="knowledge-base" element={<KnowledgeBase />} />
        <Route path="incidents" element={<Incidents />} />
        <Route path="incidents/new" element={<NewIncident />} />
        <Route path="incidents/:id" element={<ReportEditor />} />
        <Route path="settings" element={<Settings />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
